'use es6';

import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('customer-data-sidebar', {
  library: 'customer-data-sidebar'
});